import { List } from "@mui/material";
import { FileEntry } from "model";
import RelevantFileEntryListItem from "./RelevantFileEntryListItem";

export default function RelevantFileEntryList({
  fileEntries: sortedFileEntries,
}: {
  fileEntries: Array<FileEntry>;
}) {
  return (
    <List>
      {sortedFileEntries.map((event: FileEntry) => {
        return (
          <RelevantFileEntryListItem
            fileEntry={event}
            key={`re-listitem-${event.guid}`}
          />
        );
      })}
    </List>
  );
}
